<template>
	<div class="talent-data-tab">
		<p class="yx-color-text-secondary font-h6-regular mb-8 text-align-right">非官方数据，仅供参考</p>
		<template v-if="$isDy()">
			<data-card title="直播数据概览" ref="liveDataCard" :timeList="timeList" :show-time="false" :list="liveDataList" @submit="selectLiveTime" />
			<data-card
				class="mt-12"
				title="视频数据概览"
				ref="videoDataCard"
				:timeList="timeList"
				:show-time="false"
				:list="videoDataList"
				@submit="selectVideoTime"
			/>
		</template>
		<core-card v-if="$isKs()" :cron-data="cron_data" />
		<spCoreCard v-if="$isSp()" :cron-data="cron_spData" />
		<fans-card class="mt-24" :list="getList('fans_feature')" v-if="$isDy()" />
		<fans-card class="mt-24" :list="KSFansList" v-if="$isKs()" />
		<div class="goods-wrap" v-if="$isPlatOr(['Dy', 'Ks'])">
			<div class="flex flex-just-between">
				<div class="label">带货分析</div>
				<div class="fz-14 go-goods" v-if="$isDy() && isShowGoods" @click="goToGoods">
					<span class="mr-8">带货商品</span>
					<i class="el-icon-arrow-right"></i>
				</div>
			</div>
			<div class="flex mt-24">
				<template v-if="$isDy()">
					<div class="flex-1 mr-16" key="live_cate">
						<div class="table-title">热卖Top3类目</div>
						<div class="table-border">
							<el-table :data="getList('live_cate')" header-row-class-name="table-header-row" row-class-name="table-row">
								<el-table-column label="排名" min-width="50">
									<template v-slot="{ $index }">
										<serial :index="$index + 1" />
									</template>
								</el-table-column>
								<el-table-column prop="category" label="类目" min-width="100"></el-table-column>
								<el-table-column prop="average_price" label="均价" min-width="100"></el-table-column>
								<el-table-column prop="gmv" label="销售额" min-width="100"></el-table-column>
								<template v-slot:empty>
									<table-empty />
								</template>
							</el-table>
						</div>
					</div>
					<div class="flex-1" key="live_brand">
						<div class="table-title">热卖Top3品牌</div>
						<div class="table-border">
							<el-table :data="getList('live_brand')" header-row-class-name="table-header-row" row-class-name="table-row">
								<el-table-column label="排名" min-width="50">
									<template v-slot="{ $index }">
										<serial :index="$index + 1" />
									</template>
								</el-table-column>
								<el-table-column prop="brand" label="品牌" min-width="100"></el-table-column>
								<el-table-column prop="average_price" label="均价" min-width="100"></el-table-column>
								<el-table-column prop="gmv" label="销售额" min-width="100"></el-table-column>
								<template v-slot:empty>
									<table-empty />
								</template>
							</el-table>
						</div>
					</div>
				</template>
				<template v-if="$isKs()">
					<div class="flex-1 mr-16" key="hot_sale_brand_info">
						<div class="table-title">热卖Top10品牌</div>
						<div class="table-border">
							<el-table :data="hotSaleBrandInfo" :show-header="false" header-row-class-name="table-header-row" row-class-name="table-row">
								<el-table-column>
									<template v-slot="{ row }">
										<div class="brand-row">
											<div class="flex-1" v-for="(item, index) in row" :key="index">
												<serial v-if="+item.hotSaleBrandNo < 4" :index="+item.hotSaleBrandNo" />
												<span v-else class="num">{{ item.hotSaleBrandNo }}</span>
												<span class="ml-12">{{ item.hotSaleBrandTitle }}</span>
											</div>
										</div>
										<span>{{ row.hotSaleBrandTitle }}</span>
									</template>
								</el-table-column>
								<template v-slot:empty>
									<table-empty class="mt-12" />
								</template>
							</el-table>
						</div>
					</div>
					<div class="flex-1" key="hot_sale_channel_info">
						<div class="table-title">优势类目</div>
						<div class="table-border">
							<el-table :data="hot_sale_channel_info" :show-header="false" header-row-class-name="table-header-row" row-class-name="table-row">
								<el-table-column label="排名" min-width="50">
									<template v-slot="{ $index }">
										<serial :index="$index + 1" />
									</template>
								</el-table-column>
								<el-table-column prop="hotSaleChannelName" label="类目" min-width="150"></el-table-column>
								<el-table-column label="占比" min-width="100">
									<template v-slot="{ row }">
										<span>{{ row.hotSaleChannelRate / 100 }}%</span>
									</template>
								</el-table-column>
								<template v-slot:empty>
									<table-empty class="mt-12" />
								</template>
							</el-table>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import dataCard from '../dataCard';
import { getLiveData, getVideoData, getKSCronData, getKSFans, getKSLiveFeature, talentSphOverview } from '@/api/talentCRM';
import coreCard from './components/coreCard';
import spCoreCard from './components/spCoreCard';
import serial from './components/serial';
import tableEmpty from './components/tableEmpty';
import fansCard from './components/fansCard';
// import chart from './components/chart'

export default {
	name: 'talentDataTab',
	props: {
		anchorUid: {
			type: [String, Number],
			default: '',
		},
		anchorId: {
			type: [String, Number],
			default: '',
		},
		platformId: {
			type: [String, Number],
			default: '',
		},
		isClaim: {
			type: Boolean,
			default: true,
		},
		isShowGoods: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		dataCard,
		coreCard,
		spCoreCard,
		serial,
		tableEmpty,
		fansCard,
		// chart
	},
	data() {
		return {
			timeList: [
				{ value: 7, label: '近7天' },
				{ value: 30, label: '近30天' },
				{ value: 90, label: '近90天' },
			],
			liveDay: 30,
			videoDay: 30,
			liveInfo: {},
			videoInfo: {},
			cron_data: {},
			cron_spData: {},
			KSFansList: [],
			hot_sale_brand_info: [],
			hot_sale_channel_info: [],
		};
	},
	computed: {
		liveDataList() {
			const { liveDay, liveInfo } = this;
			const init = '--';
			const {
				live_num = init,
				product_num = 0,
				shop_num = 0,
				live_viewer = init,
				live_time = 0,
				sale = init,
				// , convert_rate	= 0
			} = liveInfo[liveDay] || {};
			return [
				{ label: '直播场次', desc: '', number: live_num },
				{ label: '推广商品数', desc: '', number: product_num },
				{ label: '合作店铺数', desc: '', number: shop_num },
				{ label: '直播观看人数', desc: `近${liveDay}天卖货直播的观看人数的中位数`, number: live_viewer },
				{ label: '平均在线时长', desc: `近${liveDay}天的带货直播，各场直播观看用户的平均观看时长`, number: live_time, second: true },
				{ label: '场均销售额', desc: `近${liveDay}天带货直播场次的平均GMV，剔除开播时间小于25分钟的直播`, number: sale },
				// { label: '转化指数', desc: '转化指数根据达人直播间商品点击到订单的转化率，以及销售额综合计算得出', number: convert_rate	 },
			];
		},
		videoDataList() {
			const { videoDay, videoInfo } = this;
			const { video_num = 0, video_viewer = 0, product_num = 0 } = videoInfo[videoDay] || {};
			return [
				{ label: '带货视频数', number: video_num },
				{ label: '播放量中位数', desc: '带货视频的播放量中位数', number: video_viewer },
				{ label: '带货商品数', number: product_num },
			];
		},
		getList() {
			return key => {
				const { liveDay, liveInfo } = this;
				const info = liveInfo[liveDay] || {};
				return info[key] || [];
			};
		},
		hotSaleBrandInfo() {
			const { hot_sale_brand_info = [] } = this;
			hot_sale_brand_info.forEach(item => (item.hotSaleBrandNo = (item.hotSaleBrandNo + '').padStart(2, 0)));
			const halfLen = Math.ceil(hot_sale_brand_info.length / 2);
			const result = [];
			for (let i = 0; i < halfLen; i++) {
				const row = [hot_sale_brand_info[i]];
				const item = hot_sale_brand_info[halfLen + i];
				item && row.push(item);
				result.push(row);
			}
			return result;
		},
	},
	methods: {
		selectLiveTime(liveDay) {
			this.liveDay = liveDay;
		},
		selectVideoTime(videoDay) {
			this.videoDay = videoDay;
		},
		getInfo() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.getDyData,
				[dataMap.PLATFORM_KS.value]: this.getKsData,
				[dataMap.PLATFORM_SP.value]: this.getSpData,
			};
			temPF[this.platformId]();
		},
		getDyData() {
			this.$refs.liveDataCard.reset(1);
			this.$refs.videoDataCard.reset(1);
			this.getLiveData();
			this.getVideoData();
		},
		async getKsData() {
			const res = await Promise.all([this.getKSCronData(), this.getKSFans(), this.getKSLiveFeature()]);
			const isEmpty = res.every(item => item == 0);
			isEmpty && this.$emit('destoryTalentDataTab');
		},
		async getKSCronData() {
			const { anchorId: anchor_id } = this;
			if (!anchor_id) return;
			const { code, data: { cron_data = {} } = {} } = await getKSCronData({ anchor_id });
			if (code !== 0) return;
			this.cron_data = cron_data;
			return cron_data.id;
		},
		async getKSFans() {
			const { anchorId: anchor_id } = this;
			if (!anchor_id) return;
			const { code, data: { fans_info: { fans_feature = {}, id } = {} } = {} } = await getKSFans({ anchor_id });
			if (code !== 0) return;
			this.KSFansList = fans_feature.title ? [fans_feature] : [];
			return id;
		},
		async getKSLiveFeature() {
			const { anchorId: anchor_id } = this;
			if (!anchor_id) return;
			const { code, data: { live_feature: { hot_sale_brand_info = [], hot_sale_channel_info = [], id } = {} } = {} } = await getKSLiveFeature({
				anchor_id,
			});
			if (code !== 0) return;
			this.hot_sale_brand_info = hot_sale_brand_info;
			this.hot_sale_channel_info = hot_sale_channel_info;
			return id;
		},
		async getLiveData() {
			const { anchorUid: anchor_uid } = this;
			if (!anchor_uid) return;
			const { code, data: { list = [] } = {} } = await getLiveData({ anchor_uid });
			if (code !== 0) return;
			this.liveInfo = list;
		},
		async getVideoData() {
			const { anchorUid: anchor_uid } = this;
			if (!anchor_uid) return;
			const { code, data: { list = [] } = {} } = await getVideoData({ anchor_uid });
			if (code !== 0) return;
			this.videoInfo = list;
		},
		async getSpData() {
			const { anchorId } = this;
			const { code, data } = await talentSphOverview({ anchorId });
			if (code !== 0) return;
			this.cron_spData = data;
		},
		reset() {
			this.liveDay = 30;
			this.videoDay = 30;
			this.liveInfo = {};
			this.videoInfo = {};
			this.cron_data = {};
			this.cron_spData = {};
			this.KSFansList = [];
			this.hot_sale_brand_info = [];
			this.hot_sale_channel_info = [];
		},
		goToGoods() {
			this.$emit('handlerTab', '4');
		},
	},
};
</script>

<style lang="less" scoped>
.talent-data-tab {
	padding: 0 28px 16px 12px;
	color: #333;
	.label {
		font-size: 16px;
		font-weight: bold;
	}
	.goods-wrap {
		margin-top: 24px;
		.table-title {
			width: 100%;
			height: 40px;
			line-height: 40px;
			background-color: rgba(36, 117, 255, 0.05);
			text-align: center;
			font-size: 14px;
			color: #333;
			border-radius: 2px;
			font-weight: bold;
		}
		.table-border {
			border: 1px solid #eee;
			border-bottom: none;
			.brand-row {
				display: flex;
				.num {
					color: #999;
				}
			}
			::v-deep {
				th {
					background-color: #fff !important;
					color: #999;
				}
				tbody {
					color: #333;
				}
				.el-table__cell {
					border-bottom: none;
				}
			}
		}
	}
	.go-goods {
		cursor: pointer;
		display: flex;
		align-items: baseline;
	}
	// .chart-wrap {
	//   display: flex;
	//   margin-top: 24px;
	//   padding-bottom: 28px;
	//   border-bottom: 1px solid #eee;
	//   .iconfont {
	//     color: #999;
	//   }
	// }
}
</style>
